// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function VerificationError({ width = "65px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 65 63"
      width={width}
      {...props}
    >
      <g transform="translate(0 -1)">
        <g transform="translate(0 1)">
          <path
            fill="#ecf0f1"
            d="M19.546,46.084l-8.711,4.767a7.828,7.828,0,0,0-1.4,1,29.1,29.1,0,0,0,37.487.1,7.726,7.726,0,0,0-1.536-1.032l-9.328-4.679a3.57,3.57,0,0,1-1.967-3.192V39.371a14.126,14.126,0,0,0,.882-1.138,21.561,21.561,0,0,0,2.9-5.862,2.938,2.938,0,0,0,2.078-2.8V25.655a2.93,2.93,0,0,0-.976-2.172V17.818S40.138,9,28.236,9s-10.742,8.817-10.742,8.817v5.666a2.926,2.926,0,0,0-.976,2.172v3.919a2.941,2.941,0,0,0,1.351,2.466A19.471,19.471,0,0,0,21.4,39.371v3.581A3.574,3.574,0,0,1,19.546,46.084Z"
            transform="translate(0.96 -0.158)"
          />
          <g id="Group_1361" data-name="Group 1361">
            <path
              fill="#556080"
              d="M29.694,1A29.289,29.289,0,0,0,10.409,52.682a7.758,7.758,0,0,1,1.385-.988L20.5,46.927a3.572,3.572,0,0,0,1.854-3.133V40.213a19.453,19.453,0,0,1-3.532-7.331,2.942,2.942,0,0,1-1.351-2.466V26.5a2.93,2.93,0,0,1,.976-2.172V18.659s-1.16-8.817,10.742-8.817,10.742,8.817,10.742,8.817v5.666a2.926,2.926,0,0,1,.976,2.172v3.919a2.938,2.938,0,0,1-2.078,2.8,21.561,21.561,0,0,1-2.9,5.862,14.126,14.126,0,0,1-.882,1.138v3.672a3.569,3.569,0,0,0,1.967,3.192l9.328,4.679a7.766,7.766,0,0,1,1.531,1.03A29.3,29.3,0,0,0,29.694,1Z"
              transform="translate(0 -1)"
            />
          </g>
        </g>
        <g transform="translate(38.559 37.474)">
          <ellipse
            fill="#f63f27"
            cx="13.22"
            cy="13.263"
            rx="13.22"
            ry="13.263"
          />
          <path
            fill="#fff"
            d="M49.091,46.552l3.9-3.908a1.1,1.1,0,0,0-1.558-1.563l-3.9,3.908-3.9-3.908a1.1,1.1,0,1,0-1.558,1.563l3.9,3.908-3.9,3.908a1.1,1.1,0,1,0,1.558,1.563l3.9-3.908,3.9,3.908a1.1,1.1,0,0,0,1.558-1.563Z"
            transform="translate(-34.313 -33.289)"
          />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/VerificationError.js